var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#085488",
    d: "M2.5 1.5v9c0 .19.107.362.277.448.169.083.371.065.523-.048l6-4.5c.126-.094.2-.243.2-.4 0-.157-.074-.306-.2-.4l-6-4.5c-.151-.114-.354-.132-.523-.047-.17.084-.277.257-.277.447z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseUp);
export default __webpack_public_path__ + "static/media/collapse-up.a985bfad048ec26e19c0aa6f5a99ceff.svg";
export { ForwardRef as ReactComponent };